
export const APPRAISAL_PROGRAM = 'yiT00XKrrHP'; // or a new program if preferred

export const APPRAISAL_PROGRAM_STAGES = {
  MID_YEAR: 'xbEyVHbXlGK',
  YEAR_END: 'wEsUvf2luKr',
};

export const DATA_ELEMENTS = {
  APPRAISAL_STATUS: 'cA753DO19RI',
  EMPLOYEE_SELF_RATING_TASK: 'CAx2MUxKaAl',
  EMPLOYEE_SELF_RATING_BEHAVIOURAL: 'FI5gjGSagB5',
  EMPLOYEE_COMMENTS: 'toGkgVQbRbg',
  MANAGER_RATING_TASK: 'UKDk6cPVEha',
  MANAGER_RATING_BEHAVIOURAL: 'pAGDYpY5X6f',
  MANAGER_COMMENTS: 'XjGPqk429bR',
  MANAGER_BUSINESS_COMMENTS: 'iRW7Q1Jm0bQ',

  EMPLOYEE_RESPONSE_STATUS: 'f0CbZkjcr0c', // 'accepted' or 'disputed'
  EMPLOYEE_RESPONSE_REMARKS: 'aMVaa2KB1bk',
  EMPLOYEE_ACCEPTED_RATING_TASK: 'numuvI1RFZB',
  EMPLOYEE_ACCEPTED_RATING_BEHAVIOURAL: 'XHXDAxydLXx',

  EMPLOYEE_COMPETENCY_RATINGS: 'Gl4m70qBOKU',
  EMPLOYEE_COMPETENCY_COMMENTS: 'WNmm8eekzwm',

  MANAGER_COMPETENCY_RATINGS: 'OtOKdIzF8EJ',
  MANAGER_COMPETENCY_COMMENTS: 'qYqrQ0pUkBN',
};

export const OBJECTIVE_APPRAISAL_DE = {
  SELF_RATING: 'Twk8uxfdOmT',      
  SELF_COMMENTS: 'fjIgDhvpmIK',
  BUS_MANAGER_COMMENTS: 'SRKqXMnZiEL',
  BUS_MANAGER_RATING: 'UtT7eLokuAD',      
};

// Option codes (values stored in the data element)
export const APPRAISAL_STATUSES = {
  DRAFT: 'draft',        // ← lowercase code
  SUBMITTED: 'submitted',
  REVIEWED: 'reviewed',
  FINALIZED: 'finalized',
  RETURNED: 'returned', 
};


// Option codes (values stored in the data element)
export const APPRAISAL_STATUS_CODES = {
  DRAFT: 'draft',        // ← lowercase code
  SUBMITTED: 'submitted',
  REVIEWED: 'reviewed',
  FINALIZED: 'finalized',
  RETURNED: 'returned', 
};